import { useState } from "react";

const faqs = [
  {
    q: "Is the Tuatara 1000 EFI suitable for farm use?",
    a: "Yes, the Tuatara 1000 EFI is purpose-built for demanding farm, agricultural, and commercial applications."
  },
  {
    q: "What is the towing capacity of the Tuatara 1000 EFI?",
    a: "The Tuatara 1000 EFI offers an impressive towing capacity of up to 1000kg."
  },
  {
    q: "Is the Tuatara an ATV or a UTV?",
    a: "While often referred to as an ATV, the Tuatara is more accurately classified as a side-by-side UTV."
  },
  {
    q: "What safety features does the Tuatara include?",
    a: "It includes certified ROPS, seat belts, optional enclosed cabin, and other safety-focused design elements."
  },
  {
    q: "How can I contact Tuatara for more information?",
    a: "You can use the Contact Us button or the enquiry form at the bottom of this page."
  }
];

const NZPetrolFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="bg-white pb-[80px]">
      <div className="max-w-[900px] mx-auto px-[20px]">
        {/* H2 */}
        <h2 className="text-[28px] md:text-[32px] kuunari-bold text-center mb-[40px]">
          You may still have questions
        </h2>

        {/* Accordion */}
        <div className="space-y-4">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                className="border border-[#d1d1d1] rounded-md overflow-hidden"
              >
                <button
                  onClick={() =>
                    setOpenIndex(isOpen ? null : index)
                  }
                  className="w-full flex justify-between items-center px-6 py-4 text-left 
                             text-[16px] md:text-[18px] font-semibold text-[#333] bg-[#f9f9f9]"
                >
                  <span>{item.q}</span>

                  {/* Arrow */}
                  <span
                    className={`text-[22px] transition-transform duration-300 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  >
                    ▾
                  </span>
                </button>

                {isOpen && (
                  <div className="px-6 pb-5 text-[#666] text-[15px] leading-[26px] bg-white">
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default NZPetrolFAQ;
